import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { validateKnowledgeSearch } from '../lib/knowledge-search.js';

// Lazy so the Knowledge page and its editor stay out of the entry chunk.
const KnowledgePage = React.lazy(() =>
  import('../components/knowledge/page.js').then((module) => ({ default: module.KnowledgePage })),
);

// Shared by the top-level and the workspace-scoped route so both serve the same page.
export function KnowledgeRouteComponent() {
  return (
    <React.Suspense fallback={null}>
      <KnowledgePage />
    </React.Suspense>
  );
}

export const Route = createFileRoute('/knowledge')({
  component: KnowledgeRouteComponent,
  validateSearch: validateKnowledgeSearch,
});
